import { formValidationSchemaNoChanged } from '../../Form'
import {
  getGretaAIChatNameFormValidationSchema,
  GRETA_AI_CHAT_NAME_FORM_FIELD_NAME_NAME,
} from '../GretaAIChatNameField'

function getIsGretaAIChatNameUnchanged({ initialValues, values }) {
  return (
    initialValues[GRETA_AI_CHAT_NAME_FORM_FIELD_NAME_NAME].trim() ===
    values[GRETA_AI_CHAT_NAME_FORM_FIELD_NAME_NAME].trim()
  )
}

export function getGretaAIChatRenameModalValidationSchema({
  initialValues,
  maxLength,
}) {
  return getGretaAIChatNameFormValidationSchema(maxLength).concat(
    formValidationSchemaNoChanged({
      initialValues,
      isEqual: getIsGretaAIChatNameUnchanged,
    })
  )
}
